import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, switchMap, throwError } from "rxjs";
import { AuthService } from "../services/auth.service";
import { LocalStorageService } from "../services/local-storage.service";
import { Router } from "@angular/router";

export const logoutInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const localStorageService = inject(LocalStorageService);
    const router = inject(Router);
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && localStorageService.getToken()) {
                return authService.refresh().pipe(
                    switchMap((token) => {
                        if (token.token) {
                            localStorageService.setToken(token.token);
                            const cloned = req.clone({
                                headers: req.headers.set("Authorization", "Bearer " + token.token),
                            });
                            return next(cloned);
                        } else {
                            localStorageService.removeToken();
                            authService.resetActiveUser();
                            router.navigate(["/"]);
                            return next(req);
                        }
                    })
                );
            } else if (error.status === 401 && !localStorageService.getToken()) {
                router.navigate(["/"]);
                authService.resetActiveUser();
                return throwError(() => error);
            } else {
                // router.navigate([""]);
                return throwError(() => error);
            }
        })
    );
};
